<template>
  <div v-if="all">
    <div v-for="card in all" :key="`all-${card.id}`" class="persona-card">
      <v-row>
        <v-col cols="4">
          <!-- Image  -->
          <v-img :src="card.doc.image" class="preview" v-if="card.doc.image" />
          <!-- Persona  -->
          <!-- Description -->
          <!-- Gender  -->
          <!-- Age  -->
          <!-- Location -->
          <!-- Competencies -->

          <div v-for="field in competency" :key="`text-${field.model}`">
            <h3 class="subtitle-2 ma-0 black--text overline">
              {{ field.label }}
            </h3>
            <v-rating
              :readonly="true"
              color="deep-orange"
              class="ma-0"
              background-color="grey lighten-1"
              v-model="card.doc[field.model]"
            ></v-rating>
          </div>
        </v-col>
        <v-col cols="8">
          <v-row>
            <v-col cols="12"
              ><h3>Interests</h3>
              <v-tag v-for="item in card.doc.sites" :key="item">{{
                item
              }}</v-tag>
            </v-col>
            <v-col cols="4"
              ><v-card light height="100%">
                <v-card-title>What are their needs</v-card-title>
                <v-card-text
                  ><ul>
                    <li v-for="item in card.doc.needs" :key="item">
                      {{ item }}
                    </li>
                  </ul></v-card-text
                >
              </v-card></v-col
            >
            <v-col cols="4"
              ><v-card light height="100%">
                <v-card-title>What are their goals</v-card-title>
                <v-card-text
                  ><ul>
                    <li v-for="item in card.doc.theirGoal" :key="item">
                      {{ item }}
                    </li>
                  </ul></v-card-text
                >
              </v-card></v-col
            >
            <v-col cols="4"
              ><v-card light height="100%">
                <v-card-title>What are our goals</v-card-title>
                <v-card-text
                  ><ul>
                    <li v-for="item in card.doc.ourGoal" :key="item">
                      {{ item }}
                    </li>
                  </ul></v-card-text
                >
              </v-card></v-col
            >
            <v-col cols="6"
              ><h3>What could be their frustrations</h3>
              <ul>
                <li v-for="item in card.doc.frustrations" :key="item">
                  {{ item }}
                </li>
              </ul></v-col
            >
            <v-col cols="6"
              ><h3>In an ideal world</h3>
              <div v-html="card.doc.ideal"></div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// import lodash from "lodash";

const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsPresentation",
  data() {
    return {
      items: null,
      admins: null,
      users: null,
      all: null,
      coreLeft: [
        {
          label: "Persona",
          model: "persona",
        },
        {
          label: "Gender",
          model: "gender",
        },
        {
          label: "Occupation",
          model: "occupation",
        },
        {
          label: "Location",
          model: "location",
        },
        {
          label: "Age",
          model: "age",
        },
      ],
      coreRight: [
        {
          label: "Description",
          model: "description",
        },
        {
          label: "Interests",
          model: "interests",
        },
        {
          label: "Related websites",
          model: "sites",
        },
      ],
      competency: [
        {
          label: "Internet",
          model: "internet",
        },
        {
          label: "Social Media",
          model: "social",
        },
        {
          label: "Messaging",
          model: "messaging",
        },
        {
          label: "Games",
          model: "games",
        },
        {
          label: "Apps",
          model: "apps",
        },
      ],
      goals: [
        {
          label: "What are their needs?",
          model: "needs",
        },
        {
          label: "What are their goals?",
          model: "theirGoal",
        },
        {
          label: "What are our goals?",
          model: "ourGoal",
        },
        {
          label: "Would could be their frustrations?",
          model: "frustrations",
        },
      ],
      end: [
        {
          label: "In an ideal world we would like...",
          model: "ideal",
        },
      ],
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getAdmins();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAdmins() {
      console.log("admins");
      let ref = fb.profilesCollection.where("webrole", "==", "admin");
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post.uid);
          });
          if (items) {
            this.admins = items;
          }
          this.getExercise();
        })
        .catch(function() {});
    },
    getExercise() {
      console.log("exercise");
      this.doc = null;
      let ref = fb.personaExCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            // if (!this.admins.some((x) => x == post.uid)) {
            //   items.push(post);
            // }
            items.push(post);
          });
          if (items) {
            this.all = items;
          }
        })
        .catch(function() {});
    },
  },
};
</script>

<style lang="scss">
.preview {
  width: 100%;
  height: auto;
}
</style>
